import { UseQueryResult, useQuery } from 'react-query'
import { request } from '../request'
import { DateRange } from '../../lib/types/DateRange'
import { useBuildQueryParams } from '../../lib/hooks/useBuildQueryParams'

export type CurrencyMetricsType = Array<{
  upload_id: number
  date: string
  upload_type: string
  local_currency_code: string
  local_currency: string
  local_currency_symbol: string
  target_currency_code: string
  target_currency: string
  target_currency_symbol: string
  cost_basis: number
  fees: number
  amount_sent: number
  amount_received: number
}>
export const useGetCurrencyMetrics = ({
  dateRange,
}: {
  dateRange: DateRange
}): UseQueryResult<CurrencyMetricsType, Error> => {
  const queryParams = useBuildQueryParams(dateRange.dateRange)

  return useQuery(['reports', 'currency', 'metrics', { queryParams }], () =>
    request<CurrencyMetricsType>({
      url: '/reports/currency/metrics',
      method: 'GET',
      params: {
        ...queryParams,
      },
    }),
  )
}
